import { Document, Page, View } from "@react-pdf/renderer";
import * as React from "react";
import WebOrderPdfDetails from "./WebOrderPdfDetails";
import { OrderPdfProps } from "../types";
import OrderDetailsPdf from "../OrderDetailsPdf";
import OrderCostSummaryPdf from "../OrderCostSummaryPdf";

const WebOrderPDF = (props: OrderPdfProps) => {
  const { user, order, currentCostingVersion, styles } = props;

  return (
    <Document>
      <Page style={styles.pageStyles}>
        <OrderDetailsPdf {...props} />

        <View>
          <WebOrderPdfDetails />
        </View>

        <OrderCostSummaryPdf
          user={user}
          order={order}
          currentCostingVersion={currentCostingVersion}
          styles={styles}
        />
      </Page>
    </Document>
  );
}

export default WebOrderPDF;
